import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import i18next from 'i18next';

import { Message } from '../Message';
import { PageTitle } from '../PageTitle';
import ChecklistUserForm from './checklist_user_form';
import { ChecklistUserService } from '../../services';

@connect(state => {
  return {
    me: state.user.me
  }
})
class ChecklistUserAdd extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            saved: false,
            submitting: false,
            localErrorMessage: null,
            localSuccessMessage: null
        }
    }

    handleSubmit(data) {
      this.setState({submitting: true});
      
      const user = {
        fullName: data.fullName,
        deviceGroupings: data.deviceGroupings.map(grouping => ({'id': grouping.value})),
        enterprise: {'id': this.props.me.enterprise.id}
      }

      ChecklistUserService.add(user).then((response) => {
        this.setState({saved: true});
      }).catch((err) => {
        this.setState({localErrorMessage: i18next.t('messages.error-saving-checklist-user')})
        console.error(err);
      });
    }

    messageDismissCallback() {
        this.setState({
          localErrorMessage: null,
          localSuccessMessage: null
        });
      }

    renderMessages() {
        if (this.state.localErrorMessage) {
          return (
              <Message errorMessage={ this.state.localErrorMessage } messageDismissCallback={ this.messageDismissCallback.bind(this) } />
          );
        }
    
        if (this.state.localSuccessMessage) {
          return (
              <Message messages={{ state: { successMessage: this.state.localSuccessMessage } }} messageDismissCallback={ this.messageDismissCallback.bind(this) } />
          );
        }
    
        if (this.props.location.state) {
          return (
              <Message messages={ this.props.location } />
          );
        }
        return null;
      }

    render() {
        if (this.state.saved) {
          return (
              <Redirect to={{
                pathname: '/config/checklist/users',
                state: {
                  successMessage: i18next.t('messages.checklist-user-saved')
                }
              }}/>
          );
        } else if (this.state.submitting) {
            return (
              <div className="loader">{i18next.t('loading')}</div>
          );
        } else {
          const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
          return (
              <div>
                <div className="row">
                  <PageTitle title={i18next.t('pages.checklist-users.add-checklist-user')}
                             backLinkWithParams={{
                               link: {
                                 pathname: "/config/checklist/users",
                                 search: backLinkSearch
                               }
                             }} />
                </div>
                {this.renderMessages()}
                <div className="op-content-box tree-form">
                  <h4 className="remove-margin-bottom"/>
                  <div className="row">
                      <ChecklistUserForm
                        onSubmit={this.handleSubmit.bind(this)}
                      />
                  </div>
                </div>
              </div>
          );
        }
      }
}

export default ChecklistUserAdd;